import React from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import { RootState } from "../redux/root-store";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
    position: fixed;
    bottom: 5px;
    display: flex;
    justify-content: center;
    width: 100vw;
    z-index: 20;
`;

const Span = styled.span`
    color: white;
    background-color: black;
    padding: 0rem 20px;
    border-radius: 20px;
    cursor: pointer;
`;

const mapStateToProps = (state: RootState) => ({
    loggedUser: state.session.user,
});

interface Props extends ReturnType<typeof mapStateToProps> {}

const TrialBanner = (props: Props) => {
    const { loggedUser } = props;
    const navigate = useNavigate();
    if (!loggedUser) return null;
    const diff = dayjs().diff(loggedUser.startTrialDate) / 1000 / 60 / 60 / 24;
    if (
        loggedUser.purchase_name.toLowerCase() === "meet and greet" &&
        diff < loggedUser.numberOfTrialDays &&
        diff > 0
    ) {
        return (
            <Container className="trial-banner">
                <Span
                    onClick={() => {
                        navigate("/purchase");
                    }}
                >
                    {Math.max(
                        0,
                        loggedUser.numberOfTrialDays - Math.floor(diff)
                    )}{" "}
                    days left in your free trial
                </Span>
            </Container>
        );
    }
    return null;
};

export default connect(mapStateToProps, {})(TrialBanner);
